import { ActionMenuItem } from '@shared/components/action-menu/action-menu-item.model';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';
import { AffiliateActions } from './affiliate-actions-enum';
import { useActionMenuComposable } from '@shared/components/action-menu/action-menu-composable';

export const useAffiliateActionMenu = () => {
  // Composable logic for navigation menu can be added here
  const validatePermission = CHECK_PERMISSIONS();
  const actionMenuHelper = useActionMenuComposable();
  const affiliateActionMenuItems: ActionMenuItem[] = [
    {
        title:'Details', 
        icon:'info',
        route:'/affiliates',
        validPermission: validatePermission.canReadAffiliates(),
        action: AffiliateActions.PageChange,
    },
    {
        title:'Deactivate', 
        statefulTitle: actionMenuHelper.getTruthyStatefulTitle,
        icon:'block',
        route:'/affiliates',
        validPermission: validatePermission.canReadAffiliates(),
        action: AffiliateActions.Toggled,
    },
  ];
  return{
    affiliateActionMenuItems
  }
};